export enum UserStatus {
  ALL = "all",
  INACTIVE = "USER_STATUS_INACTIVE",
  ACTIVE = "USER_STATUS_ACTIVE",
  NOT_VERIFIED = "USER_STATUS_NOT_VERIFIED"
}

export interface AddOrganizationUserRequest {
  fullname: string;
  phone_number: string;
  email_address: string;
  country_id: string;
  timezone_id: string;
  language_code: string;
  status: UserStatus;
  user_group_ids: string[] | null;
}

export interface AddOrganizationUserResponse {
  id: string;
}

export interface UsersPaginationMeta {
  pagination: {
    per_page: number;
    total: number;
    total_pages: number;
  };
}

export interface CreateUserDetails {
  id: string;
  fullname: string;
  phone_number: string;
  email_address: string;
  country_id: string;
  timezone_id: string;
  language_code: string;
  status: UserStatus;
}
export interface CreateUserListResponse {
  data: CreateUserDetails[];
}

export interface GetUsersDetail {
  id: string;
  organization_id: string;
  fullname: string;
  email_address: string;
  group: {
    id: string;
    name: string;
  };
  last_signin_at: string;
  created_at: string;
  created_by: string;
  updated_at: string;
  updated_by: string;
  status: UserStatus;
}

export interface UserDetailFlat {
  id: string;
  organization_id: string;
  fullname: string;
  email_address: string;
  group_id: string;
  group_name: string;
  last_signin_at: string;
  created_at: string;
  created_by: string;
  updated_at: string;
  updated_by: string;
  status: UserStatus;
}
export interface GetUsersResponse {
  data: GetUsersDetail[];
  meta: UsersPaginationMeta;
}

export interface FlattenGetUsersResponse {
  data: UserDetailFlat[];
  meta: UsersPaginationMeta;
}

export interface GetUsersPayload {
  query?: string | null;
  status?: UserStatus | null;
  sort_by?: string | null;
  order_by?: "asc" | "desc" | null;
  page?: number;
  per_page?: number;
  group_id?: string | null;
}

export interface GetUserByIdDetail {
  full_name: string;
  email_address: string;
  phone_number: string;
  status: Exclude<UserStatus, UserStatus.ALL>;
  updated_at: string;
  country: { code: string; name: string };
  timezone: { code: string; name: string };
  language: { code: string; name: string };
  groups: {
    id: string;
    name: string;
    description: string;
    group_member_id: string;
  }[];
}

export interface PatchUserPayload {
  fullname: string;
  phone_number: string;
  email_address: string;
  country_id: string;
  timezone_id: string;
  language_code: string;
  status: Exclude<UserStatus, UserStatus.ALL>;
  group_id: string;
  group_member_id: string;
}

export type DeleteUserPayload = { id: string; fullname: string };
